import Loading from "./components/Loading";
import { StrictMode, Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";
import { DynamicModulesProvider } from "./contexts/DynamicModuleProvider";
import Routes from "./routes";
import { globalStyles } from "./styles/global";
import { createRoot } from "react-dom/client";
globalStyles();

const AzureProvider = lazy(() => import("mfeAuth/AzureProvider"));
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <StrictMode>
    <Suspense fallback={<Loading />}>
      <AzureProvider>
        <DynamicModulesProvider>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </DynamicModulesProvider>
      </AzureProvider>
    </Suspense>
  </StrictMode>,
);
